module.exports = __webpack_public_path__ + "img/exam_jan_2025_2l4bmjba.1cc7a783.jpg";